<template>
  <div>
    <CRow class="mb-3">
      <CCol sm="12">
        <CAlert color="info" class="mb-3">
          <strong>
            <translate translate-context="tag_definitions.form">Tags Input Type</translate>
          </strong>
          <p class="mb-0 mt-2">
            <translate translate-context="tag_definitions.form">
              This input type allows users to add multiple tags as badges with autocomplete suggestions.
              Users can type freely and press Enter to add tags. The system will learn from usage and suggest popular values.
            </translate>
          </p>
        </CAlert>
      </CCol>
    </CRow>

    <!-- Show suggestions if available (read-only info) -->
    <CRow v-if="hasSuggestions" class="mb-3">
      <CCol sm="12">
        <label class="mb-2">
          <translate translate-context="tag_definitions.form">Current Suggestions</translate>
          <small class="text-muted ml-2">
            (<translate translate-context="tag_definitions.form">Read-only, auto-generated from usage</translate>)
          </small>
        </label>
        <div class="suggestions-preview">
          <CBadge
            v-for="suggestion in displayedSuggestions"
            :key="suggestion.value"
            color="light"
            class="mr-2 mb-2"
          >
            {{ suggestion.value }}
          </CBadge>
          <span v-if="totalSuggestions > maxDisplayed" class="text-muted">
            <translate translate-context="tag_definitions.form">
              and {{ totalSuggestions - maxDisplayed }} more...
            </translate>
          </span>
        </div>
        <small class="text-muted">
          <translate translate-context="tag_definitions.form">
            These values are automatically suggested based on previous usage.
          </translate>
        </small>
      </CCol>
    </CRow>

    <!-- Info if no suggestions yet -->
    <CRow v-else class="mb-3">
      <CCol sm="12">
        <small class="text-muted">
          <translate translate-context="tag_definitions.form">
            No suggestions yet. Suggestions will be generated automatically as users apply this tag.
          </translate>
        </small>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "TagsInputConfig",
  data() {
    return {
      config: {
        type: 'tags'
      },
      suggestedValues: [],
      maxDisplayed: 10
    }
  },
  computed: {
    hasSuggestions() {
      return this.suggestedValues && this.suggestedValues.length > 0
    },
    displayedSuggestions() {
      return this.suggestedValues.slice(0, this.maxDisplayed)
    },
    totalSuggestions() {
      return this.suggestedValues.length
    }
  },
  methods: {
    onReset(data) {
      this.config = {
        type: 'tags',
        ...data
      }

      // Store suggested values separately for display (not part of config)
      if (data && data.suggested_values) {
        this.suggestedValues = data.suggested_values
      } else {
        this.suggestedValues = []
      }
    },
    onSave() {
      // Only return the type, no other config needed
      return {
        type: 'tags'
      }
    }
  }
}
</script>

<style scoped>
.suggestions-preview {
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  min-height: 3rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
